/**
 * i18n: business pre-registration inquiry + hub CTA — ko/en/vi/ru
 * Tuples are [ko, en, vi, ru].
 */

function pick(obj, langIndex) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  }
  return out;
}

const businessRegInquiry = {
  title: ['매장 등록 문의', 'Business registration inquiry', 'Đăng ký cửa hàng — hỏi trước', 'Запрос о регистрации'],
  lead: [
    '등록 전에 업종·수수료·서류 등 궁금한 점을 편하게 물어보세요. 로그인 없이 문의할 수 있어요.',
    'Ask about categories, fees, or documents before registering. No login required.',
    'Hỏi trước về ngành nghề, phí, giấy tờ trước khi đăng ký. Không cần đăng nhập.',
    'Спросите про категорию, комиссию или документы до регистрации. Вход не обязателен.',
  ],
  category: ['관심 업종', 'Business category', 'Ngành quan tâm', 'Категория'],
  categoryPlaceholder: ['업종 선택 (선택)', 'Select category (optional)', 'Chọn ngành (tuỳ chọn)', 'Выберите категорию (необязательно)'],
  businessName: ['상호/가게명 (선택)', 'Business name (optional)', 'Tên cửa hàng (tuỳ chọn)', 'Название (необязательно)'],
  businessNamePh: ['예: 밍고 카페', 'e.g. Mingo Cafe', 'VD: Mingo Cafe', 'напр. Mingo Cafe'],
  contact: ['연락처', 'Contact', 'Liên hệ', 'Контакт'],
  contactPh: ['이메일 또는 전화번호', 'Email or phone', 'Email hoặc SĐT', 'Email или телефон'],
  message: ['문의 내용', 'Your question', 'Nội dung hỏi', 'Вопрос'],
  messagePh: [
    '예: 배달 업종도 등록 가능한가요? 수수료가 있나요?',
    'e.g. Can delivery businesses register? Are there fees?',
    'VD: Ngành giao hàng có đăng ký được không? Có phí không?',
    'напр. Можно ли зарегистрировать доставку? Есть ли комиссия?',
  ],
  notice: [
    '남겨주신 연락처로 운영팀이 답변드립니다. 개인정보는 문의 처리 목적으로만 사용해요.',
    'Our team will reply via the contact you provide. We use this info only to handle your inquiry.',
    'Đội vận hành sẽ trả lời qua thông tin liên hệ bạn để lại. Chỉ dùng để xử lý yêu cầu.',
    'Команда ответит по указанному контакту. Данные используются только для обработки запроса.',
  ],
  submit: ['문의 보내기', 'Send inquiry', 'Gửi hỏi', 'Отправить'],
  sending: ['보내는 중…', 'Sending…', 'Đang gửi…', 'Отправка…'],
  done: ['문의가 접수됐어요', 'Inquiry submitted', 'Đã gửi yêu cầu', 'Запрос отправлен'],
  submitFail: ['전송에 실패했어요. 잠시 후 다시 시도해 주세요.', 'Could not send. Please try again.', 'Gửi thất bại. Thử lại sau.', 'Не удалось отправить. Попробуйте снова.'],
  needFields: ['연락처와 문의 내용을 입력해 주세요.', 'Please enter contact and message.', 'Hãy nhập liên hệ và nội dung.', 'Укажите контакт и сообщение.'],
  quickRegisterLink: ['이미 준비됐다면 바로 등록하기', 'Ready? Register now', 'Đã sẵn sàng? Đăng ký ngay', 'Готовы? Зарегистрироваться'],
};

const businessRegisterHub = {
  preInquiryCta: [
    '등록 전에 궁금한 점 문의하기',
    'Ask before registering',
    'Hỏi trước khi đăng ký',
    'Спросить перед регистрацией',
  ],
};

function buildLang(langIndex) {
  return {
    businessRegInquiry: pick(businessRegInquiry, langIndex),
    businessRegisterHub: pick(businessRegisterHub, langIndex),
  };
}

export const phaseBusinessRegInquiryKo = buildLang(0);
export const phaseBusinessRegInquiryEn = buildLang(1);
export const phaseBusinessRegInquiryVi = buildLang(2);
export const phaseBusinessRegInquiryRu = buildLang(3);
